<template>
  <b-navbar toggleable="lg" type="dark" variant="dark" :fixed="isMobile ? 'bottom' : 'top'">
    <b-container>
      <inertia-link class="navbar-brand" :href="route('home.index')">
        iGajda Panel
      </inertia-link>

      <b-navbar-toggle target="nav-collapse" />

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <li class="nav-item">
            <inertia-link class="nav-link" :href="route('timetables.show')">
              Terminarz
            </inertia-link>
          </li>
          <li class="nav-item">
            <inertia-link class="nav-link" :href="route('schedules.index')">
              Grafiki
            </inertia-link>
          </li>
          <li v-if="user.can_see_logs" class="nav-item">
            <inertia-link class="nav-link" :href="route('logs.reservations')">
              Historia rezerwacji
            </inertia-link>
          </li>
          <li v-if="user.can_see_stats" class="nav-item">
            <inertia-link class="nav-link" :href="route('stats.index')">
              Statystyki
            </inertia-link>
          </li>
          <li v-if="user.can_see_settings" class="nav-item">
            <inertia-link class="nav-link" :href="route('settings.index')">
              Ustawienia
            </inertia-link>
          </li>

          <b-nav-item-dropdown right>
            <template #button-content>
              <i>{{ user.name }}</i>
            </template>
            <li>
              <inertia-link class="dropdown-item" :href="route('logout')" method="post">Wyloguj</inertia-link>
            </li>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$page.props.auth.user
    },
  },
}
</script>
